/*
 * @Author: llzq
 * @Date: 2020-12-12 14:30:21
 * @Email: liuzhiqiang1@jd.com
 * @LastEditors: llzq
 * @LastEditTime: 2021-10-24 13:49:50
 * @Description:  头部注释
 */
import React, { Component } from 'react'
import {Modal} from "antd";
import './style.css'

interface iProps {
    onCancel: () => void;
    downloadUrl: string;
    downloadName: string;
    visible: boolean;
}

export default class downloadModal extends Component<iProps> {
    render() {
        let { downloadUrl, downloadName, visible, onCancel } = this.props;
        return (
            <Modal
            title="下载"
            maskClosable = {false}
            footer = {null}
            onCancel={onCancel}
            visible={visible}>
                <div className="download_modal">
                    <div className="download_icon">
                    </div>
                    <div className="download_text">
                        <a href={downloadUrl} download="下载文件">点击下载文件（{downloadName}）</a>
                    </div>
                </div>
            </Modal>
        )
    }
}
